module.exports = __webpack_public_path__ + "img/Group 3006.ba6bc5b2.svg";